module.exports = __webpack_public_path__ + "static/media/atlassian-logo.68a6d4ea.ico";


//////////////////
// WEBPACK FOOTER
// ./src/atlassian-logo.ico
// module id = 59
// module chunks = 0